/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import styles from '../navigation.module.scss';
import trackHeapEvent from '../../../../services/helpers/trackHeapEvent';
import { getPixelValue, formatImagePath } from '../../../../utils/util';

export default function MenuItem({ items = [] }) {
  const footerNavtHeapTrack = (heapEventKey) => {
    trackHeapEvent(
      { Name: 'Global Nav Footer', CTA: heapEventKey },
      'CMS_Unification'
    );
  };
  return (
    <ul className={styles.menuItems}>
      {items.map((item, index) => {
        const key = `item-${index}`;
        const content = (
          <>
            {item.navIcon && (
              <img
                className={styles.navIcon}
                src={formatImagePath(item.navIcon.path)}
                loading="lazy"
                alt={item.navIcon.alt}
                height={getPixelValue(item.navIcon.height)}
                width={getPixelValue(item.navIcon.width)}
              />
            )}
            {item.label && parse(`${item.label}`)}
            {item.image?.path && (
              <img
                src={item.image.path}
                loading="lazy"
                alt={item.image.alt}
                height={getPixelValue(item.image.height)}
                width={getPixelValue(item.image.width)}
              />
            )}
          </>
        );
        return item.link ? (
          <li key={key}>
            <a
              href={item.link}
              className={`${styles.item} ${
                item.highlighted ? styles.ctaRed : null
              }`}
              data-testid={item.label}
              onClick={() => footerNavtHeapTrack(content)}
            >
              {content}
            </a>
          </li>
        ) : (
          <div
            key={key}
            className={`${styles.item} ${
              item.className && styles[item.className]
                ? styles[item.className]
                : null
            }`}
            data-testid={item.label}
          >
            {content}
          </div>
        );
      })}
    </ul>
  );
}

MenuItem.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      link: PropTypes.string,
      image: PropTypes.shape({
        path: PropTypes.string,
        alt: PropTypes.string,
        width: PropTypes.string,
        height: PropTypes.string,
      }),
      navIcon: PropTypes.shape({
        path: PropTypes.string,
        alt: PropTypes.string,
      }),
    })
  ),
};
